import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { School } from '@app/constants';

@Component({
  selector: 'app-card-big',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-big.component.html',
  styleUrls: ['./card-big.component.less']
})
export class CardBigComponent {
  @Input() item?: any;
  @Input() kind?: string;

  public getUrl = (item: School): string => {
    //console.log('CardLogoComponent ngOnInit this.article ', this.article);
    let url = item.url;

    if (item.entityBundle === 'schools') {
      url = '/inspirace/inspirativni-skoly' + url;
    }
    else if (item.entityBundle === 'partners') {
      url = '/inspirace/inspirativni-organizace' + url;
    }

    return url;  
  }
}
